<template>
  <div class="jifen-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="规则标识">
          <el-select v-model="filterForm.code" placeholder="全部" clearable style="width: 160px;">
            <el-option label="注册奖励" value="register" />
            <el-option label="分享获客奖励" value="referral" />
            <el-option label="下单奖励" value="consume" />
            <el-option label="邀请消费奖励" value="referral_consume" />
          </el-select>
        </el-form-item>
        <el-form-item label="规则名称">
          <el-input v-model="filterForm.name" placeholder="请输入名称" clearable style="width: 180px;" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filterForm.display" placeholder="全部" clearable style="width: 120px;">
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 平台规则提示 -->
      <div class="platform-tip" v-if="platformInfo">
        <i class="el-icon-info"></i>
        <span>当前规则归属：{{ platformInfo.is_platform ? '平台规则（全局生效，所有店铺继承）' : '店铺自有规则' }}</span>
      </div>
    </el-card>

    <!-- 表格 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openAddDialog"
          disabled
        >新增规则</el-button>
      </div>

      <el-table
        v-loading="loading"
        :data="ruleList"
        height="56vh"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column prop="code" label="规则标识" width="150">
          <template slot-scope="scope">
            <el-tag size="small" :type="codeTagType(scope.row.code)">{{ scope.row.code }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="规则名称" min-width="140" />
        <el-table-column prop="type_name" label="类型" width="100" align="center" />
        <el-table-column label="规则说明" min-width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.unit_text }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单笔上限" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.max_points === 0 || scope.row.max_points === '0' ? '不限' : scope.row.max_points }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.display"
              :active-value="1"
              :inactive-value="0"
              @change="handleToggleDisplay(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="70" align="center" />
        <el-table-column prop="updated_at" label="更新时间" width="160" />
        <el-table-column label="操作" width="160" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="openEditDialog(scope.row)"
            >编辑</el-button>
            <el-button
              type="text"
              size="small"
              style="color: #f56c6c;"
              @click="handleDelete(scope.row)"
              disabled
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogMode === 'add' ? '新增积分规则' : '编辑积分规则'"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="规则标识" prop="code">
          <el-select v-model="form.code" placeholder="请选择规则标识" style="width: 100%;" :disabled="dialogMode === 'edit'">
            <el-option label="注册奖励 (register)" value="register" />
            <el-option label="分享获客奖励 (referral)" value="referral" />
            <el-option label="下单奖励 (consume)" value="consume" />
            <el-option label="邀请消费奖励 (referral_consume)" value="referral_consume" />
          </el-select>
        </el-form-item>
        <el-form-item label="规则名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入规则名称" />
        </el-form-item>
        <el-form-item label="积分类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">固定积分</el-radio>
            <el-radio :label="2">按金额比例</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.type === 1" label="固定积分" prop="fixed_points">
          <el-input-number v-model="form.fixed_points" :min="0" :step="1" style="width: 200px;" />
          <span style="margin-left: 8px; color: #999;">积分</span>
        </el-form-item>
        <template v-if="form.type === 2">
          <el-form-item label="每 X 元" prop="ratio_money">
            <el-input-number v-model="form.ratio_money" :min="0" :step="1" :precision="2" style="width: 200px;" />
            <span style="margin-left: 8px; color: #999;">元</span>
          </el-form-item>
          <el-form-item label="得 Y 积分" prop="ratio_points">
            <el-input-number v-model="form.ratio_points" :min="0" :step="1" :precision="2" style="width: 200px;" />
            <span style="margin-left: 8px; color: #999;">积分</span>
          </el-form-item>
        </template>
        <el-form-item label="单笔上限" prop="max_points">
          <el-input-number v-model="form.max_points" :min="0" :step="1" style="width: 200px;" />
          <span style="margin-left: 8px; color: #999;">0 = 不限</span>
        </el-form-item>
        <el-form-item label="状态" prop="display">
          <el-radio-group v-model="form.display">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :step="1" style="width: 200px;" />
          <span style="margin-left: 8px; color: #999;">越小越前</span>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ruleLists, ruleAdd, ruleEdit, ruleDel } from '@/api/jifen'

export default {
  name: 'JifenRules',
  data () {
    return {
      loading: false,
      ruleList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filterForm: {
        code: '',
        name: '',
        display: ''
      },
      platformInfo: null,
      // 弹窗
      dialogVisible: false,
      dialogMode: 'add',
      submitting: false,
      form: {
        id: null,
        code: '',
        name: '',
        type: 1,
        fixed_points: 0,
        ratio_money: 0,
        ratio_points: 0,
        max_points: 0,
        display: 1,
        sort: 1,
        remark: ''
      },
      rules: {
        code: [{ required: true, message: '请选择规则标识', trigger: 'change' }],
        name: [{ required: true, message: '请输入规则名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择积分类型', trigger: 'change' }]
      }
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    codeTagType (code) {
      const map = {
        register: 'success',
        referral: 'warning',
        consume: 'primary',
        referral_consume: 'danger'
      }
      return map[code] || 'info'
    },

    async fetchList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.filterForm.code) params.code = this.filterForm.code
        if (this.filterForm.name) params.name = this.filterForm.name
        if (this.filterForm.display !== '' && this.filterForm.display !== null && this.filterForm.display !== undefined) {
          params.display = this.filterForm.display
        }
        const res = await ruleLists(params)
        if (res && res.code === '0') {
          // 接口 display 返回的是字符串 '1'/'0'，统一转成数字，避免 el-switch 匹配不上
          this.ruleList = (res.data || []).map(item => ({
            ...item,
            display: Number(item.display) === 1 ? 1 : 0
          }))
          this.total = res.total || 0
          this.platformInfo = {
            rule_sh_id: res.rule_sh_id,
            is_platform: res.is_platform,
            readonly: res.readonly,
            sh_id: res.sh_id
          }
        } else {
          this.ruleList = []
          this.total = 0
          this.$message.error(res && res.msg ? res.msg : '获取积分规则失败')
        }
      } catch (error) {
        console.error('获取积分规则失败', error)
        this.ruleList = []
        this.total = 0
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.currentPage = 1
      this.fetchList()
    },

    handleReset () {
      this.filterForm = { code: '', name: '', display: '' }
      this.currentPage = 1
      this.fetchList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchList()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchList()
    },

    openAddDialog () {
      this.dialogMode = 'add'
      this.form = {
        id: null,
        code: '',
        name: '',
        type: 1,
        fixed_points: 100,
        ratio_money: 0,
        ratio_points: 0,
        max_points: 0,
        display: 1,
        sort: 1,
        remark: ''
      }
      this.dialogVisible = true
    },

    openEditDialog (row) {
      this.dialogMode = 'edit'
      this.form = {
        id: row.id,
        code: row.code,
        name: row.name,
        type: parseInt(row.type),
        fixed_points: parseInt(row.fixed_points) || 0,
        ratio_money: parseFloat(row.ratio_money) || 0,
        ratio_points: parseFloat(row.ratio_points) || 0,
        max_points: parseInt(row.max_points) || 0,
        display: parseInt(row.display),
        sort: parseInt(row.sort) || 0,
        remark: row.remark || ''
      }
      this.dialogVisible = true
    },

    closeDialog () {
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
    },

    async submitForm () {
      try {
        await this.$refs.ruleForm.validate()
      } catch (e) {
        return
      }
      this.submitting = true
      try {
        const payload = { ...this.form }
        let res
        if (this.dialogMode === 'add') {
          delete payload.id
          res = await ruleAdd(payload)
        } else {
          res = await ruleEdit(payload)
        }
        if (res && res.code === '0') {
          this.$message.success(res.message || '操作成功')
          this.dialogVisible = false
          this.fetchList()
        } else {
          this.$message.error(res && res.msg ? res.msg : '操作失败')
        }
      } catch (error) {
        console.error('提交失败', error)
        if (error && error.message) {
          this.$message.error(error.message)
        } else {
          this.$message.error('网络错误，请稍后重试')
        }
      } finally {
        this.submitting = false
      }
    },

    async handleToggleDisplay (row) {
      // 记录切换后的目标值（此时 row.display 已被 el-switch 更新）
      const newVal = Number(row.display) === 1 ? 1 : 0
      try {
        const res = await ruleEdit({ id: row.id, display: newVal })
        if (res && res.code === '0') {
          this.$message.success('状态更新成功')
        } else {
          // 失败回滚
          row.display = newVal === 1 ? 0 : 1
          this.$message.error(res && res.msg ? res.msg : '状态更新失败')
        }
      } catch (error) {
        row.display = newVal === 1 ? 0 : 1
        console.error('状态更新失败', error)
        this.$message.error(error.message || '网络错误')
      }
    },

    async handleDelete (row) {
      try {
        await this.$confirm(`确定要删除规则「${row.name}」吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      try {
        const res = await ruleDel({ id: row.id })
        if (res && res.code === '0') {
          this.$message.success(res.message || '删除成功')
          this.fetchList()
        } else {
          this.$message.error(res && res.msg ? res.msg : '删除失败')
        }
      } catch (error) {
        console.error('删除失败', error)
        this.$message.error(error.message || '网络错误')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jifen-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;
    }
  }

  .platform-tip {
    padding: 8px 12px;
    margin-top: 12px;
    background: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: 4px;
    color: #409eff;
    font-size: 13px;

    i {
      margin-right: 6px;
    }
  }

  .table-card {
    .table-header {
      margin-bottom: 12px;
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
